var app = angular.module("leonardo");

var WorkFlowStates = function($stateProvider) {

  $stateProvider.state('workflows', {
    url: '/workflows',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'workflows.workflows-instances',
    ncyBreadcrumb: {
      label : '{{ filterService.getLabelProperty() }}'
    }
  });

  $stateProvider.state('workflows.workflows', {
    url: "/workflows",
    title: 'Workflows',
    by_unit: false,
    only_filter_account: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/workflow-list.html',
        controller: 'WorkFlowListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/list.html',
        controller: 'WorkFlowList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkFlowListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Workflows'
    }
  });

  $stateProvider.state('workflows.workflows-launch', {
    url: "/workflows-launch",
    title: 'Launch Workflow',
    by_unit: false,
    only_filter_account: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/workflow-list.html',
        controller: 'WorkFlowListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/launch.html',
        controller: 'WorkFlowLaunch'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkFlowListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Launch Workflow'
    }
  });

  $stateProvider.state('workflows.workflows-instances', {
    url: "/workflows-instances",
    title: 'My Workflows',
    by_unit: false,
    workflows_in_progress: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/workflow-list.html',
        controller: 'WorkFlowListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/instances-list.html',
        controller: 'WorkFlowInstanceList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkFlowInstanceListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'My Workflows'
    }
  });

  $stateProvider.state('workflows.workflows.add', {
    url: "/add",
    title: 'Add Workflow',
    action: 'create',
    by_unit: false,
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/form.html',
        controller: 'WorkFlowForm'
      }
    },
    resolve: {
      workflowOjb: ['WorkFlowService', function(WorkFlowService) {
        return null;
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Workflow'
    }
  });

  $stateProvider.state('workflows.workflow-edit', {
    url: "/workflow/:pk/edit",
    title: 'Edit Workflow',
    action: 'edit',
    params: {
      pk: '',
      squash: false
    },
    by_unit: false,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/form.html',
        controller: 'WorkFlowForm'
      }
    },
    resolve: {
      workflowOjb: ['WorkFlowService', '$stateParams', function(WorkFlowService, $stateParams) {
        return WorkFlowService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit Workflow'
    }
  });

};

app.config(['$stateProvider', WorkFlowStates]);
